enum ManagedLocaleCodes {
  BG = "bg", // Bulgarian
  DA = "da", // Danish
  DE = "de", // German
  EL = "el", // Greek
  EN = "en", // English
  ES = "es", // Spanish
  ES_419 = "es_419", // Latin American Spanish
  FR = "fr", // French
  HE = "he", // Hebrew
  IN = "id", // Indonesian
  IT = "it", // Italian
  JA_JP = "ja_JP", // Japanese (Japan)
  NB = "nb", // Norwegian Bokmål
  PL = "pl", // Polish
  PT = "pt", // Portuguese
  RU = "ru" // Russian
}

enum AliasedLocaleCodes {
  EN_GB = "en_GB", // British English
  EN_US = "en_US", // American English
  FR_CA = "fr_CA" // French Canadian
}

export const SupportedLocaleCodes = {
  ...ManagedLocaleCodes,
  ...AliasedLocaleCodes
};

export type SupportedLocaleCodes = ManagedLocaleCodes | AliasedLocaleCodes;
